import { render, staticRenderFns } from "./SignupProcedure.vue?vue&type=template&id=64250144&"
import script from "./SignupProcedure.vue?vue&type=script&lang=js&"
export * from "./SignupProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports